function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var CreateTemplate = require('./create.template');

/**
 * Sidebar Create — RedSquare's primary post action plus publishing actions
 * supplied by other modules.
 *
 * Extension:
 *   - `registerAction({ id, label, icon?, image?, onClick })` before/after render
 *   - modules may `respondTo('redsquare-create')` with
 *     `{ id, label, icon?, image?, callback(app, mod) }`
 */
var Create = /*#__PURE__*/function () {
  function Create(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, Create);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this._extra_actions = [];
  }

  /**
   * Ordered create actions. RedSquare is always first; module extras follow.
   */
  return _createClass(Create, [{
    key: "getActions",
    value: function getActions() {
      var _this = this,
        _this$app$modules,
        _this$app$modules$get;
      var actions = [{
        id: 'post',
        label: 'New Tweet',
        image: '/saito/icons/saito-redsquare-icon-solid.svg',
        onClick: function onClick() {
          return _this.openPost();
        }
      }];
      var seen = new Set(actions.map(function (a) {
        return a.id;
      }));
      var labelOverrides = {
        'stack-publish': 'New Article'
      };
      var _iterator = _createForOfIteratorHelper(this._extra_actions),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var action = _step.value;
          if (!(action !== null && action !== void 0 && action.id) || !(action !== null && action !== void 0 && action.label) || seen.has(action.id)) {
            continue;
          }
          seen.add(action.id);
          actions.push(_objectSpread(_objectSpread({}, action), {}, {
            label: labelOverrides[action.id] || action.label
          }));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var peers = ((_this$app$modules = this.app.modules) === null || _this$app$modules === void 0 || (_this$app$modules$get = _this$app$modules.getRespondTos) === null || _this$app$modules$get === void 0 ? void 0 : _this$app$modules$get.call(_this$app$modules, 'redsquare-create')) || [];
      var _iterator2 = _createForOfIteratorHelper(peers),
        _step2;
      try {
        var _loop = function _loop() {
          var _this$app$modules2, _this$app$modules2$re, _this$app$modules3, _this$app$modules3$re;
          var item = _step2.value;
          if (!(item !== null && item !== void 0 && item.id) || !(item !== null && item !== void 0 && item.label) || seen.has(item.id)) {
            return 1; // continue
          }
          var peer = ((_this$app$modules2 = _this.app.modules) === null || _this$app$modules2 === void 0 || (_this$app$modules2$re = _this$app$modules2.returnModuleByName) === null || _this$app$modules2$re === void 0 ? void 0 : _this$app$modules2$re.call(_this$app$modules2, item.modname)) || ((_this$app$modules3 = _this.app.modules) === null || _this$app$modules3 === void 0 || (_this$app$modules3$re = _this$app$modules3.returnModule) === null || _this$app$modules3$re === void 0 ? void 0 : _this$app$modules3$re.call(_this$app$modules3, item.modname));
          seen.add(item.id);
          actions.push({
            id: item.id,
            label: labelOverrides[item.id] || item.label,
            icon: item.icon || (peer === null || peer === void 0 ? void 0 : peer.icon_fa) || (peer === null || peer === void 0 ? void 0 : peer.icon) || 'fa-solid fa-plus',
            image: item.image,
            onClick: function onClick() {
              var _item$callback;
              return (_item$callback = item.callback) === null || _item$callback === void 0 ? void 0 : _item$callback.call(item, _this.app, _this.mod);
            }
          });
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          if (_loop()) continue;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return actions;
    }

    /**
     * Register an additional create action (e.g. from a peer module at init).
     */
  }, {
    key: "registerAction",
    value: function registerAction() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!action.id || !action.label) {
        return;
      }
      this._extra_actions = this._extra_actions.filter(function (a) {
        return a.id !== action.id;
      });
      this._extra_actions.push(action);
      if (document.querySelector(this.container)) {
        this.render();
      }
    }
  }, {
    key: "openPost",
    value: function openPost() {
      var _this$mod$compose_ove;
      (_this$mod$compose_ove = this.mod.compose_overlay) === null || _this$mod$compose_ove === void 0 || _this$mod$compose_ove.open();
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (container) {
        this.container = container;
      }
      if (!document.querySelector(this.container)) {
        return;
      }
      this.app.browser.replaceElementContentBySelector(CreateTemplate(this), this.container);
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var root = document.querySelector(this.container);
      if (!root || root.dataset.createBound === '1') {
        return;
      }
      root.dataset.createBound = '1';
      root.addEventListener('click', function (e) {
        var _action$onClick;
        var toggle = e.target.closest('[data-create-toggle]');
        if (toggle && root.contains(toggle)) {
          e.preventDefault();
          _this2.toggleMenu();
          return;
        }
        var btn = e.target.closest('[data-create]');
        if (!btn || !root.contains(btn)) {
          return;
        }
        e.preventDefault();
        var id = btn.getAttribute('data-create');
        var action = _this2.getActions().find(function (a) {
          return a.id === id;
        });
        _this2.closeMenu();
        action === null || action === void 0 || (_action$onClick = action.onClick) === null || _action$onClick === void 0 || _action$onClick.call(action);
      });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          _this2.closeMenu(true);
        }
      });
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) {
          _this2.closeMenu();
        }
      });
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      var root = document.querySelector(this.container);
      var toggle = root === null || root === void 0 ? void 0 : root.querySelector('[data-create-toggle]');
      var menu = root === null || root === void 0 ? void 0 : root.querySelector('[data-create-menu]');
      if (!toggle || !menu) {
        return;
      }
      var open = menu.hidden;
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) {
        var _menu$querySelector;
        (_menu$querySelector = menu.querySelector('[data-create]')) === null || _menu$querySelector === void 0 || _menu$querySelector.focus();
      }
    }
  }, {
    key: "closeMenu",
    value: function closeMenu() {
      var restoreFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var root = document.querySelector(this.container);
      var toggle = root === null || root === void 0 ? void 0 : root.querySelector('[data-create-toggle]');
      var menu = root === null || root === void 0 ? void 0 : root.querySelector('[data-create-menu]');
      if (!toggle || !menu || menu.hidden) {
        return;
      }
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) {
        toggle.focus();
      }
    }
  }]);
}();
module.exports = Create;